module.exports = require('./lib/schema-inspector');